
import PropertyService from '../../services/properties'

export const state = {}

export const mutations = {}


export const getters = {}

export const actions = {
  // This is automatically run in `src/state/store.js` when the app
  // starts, along with any other actions named `init` in other modules.
  // eslint-disable-next-line no-unused-vars
  init({ state, dispatch }) {},

  // eslint-disable-next-line no-unused-vars
  createProperty ({ commit }, payload) {

    return new Promise((resolve, reject) => {
      
      PropertyService.createProperty(payload).then(response => { 
        if (response.data && response.data.attribute?._id) { 
          resolve(response)
        }else{
          reject({message: 'Error creating group'})
        }
      })
      .catch(error => { reject(error) })
    });
  },

  // eslint-disable-next-line no-unused-vars
  getProperties ({ commit },params) {

    return new Promise((resolve, reject) => { 
      PropertyService.getProperties(params).then(response=> {
        resolve(response.data)
    })
    .catch(error=>{ reject(error) })
    });
  },
  
  // eslint-disable-next-line no-unused-vars
  deleteProperty({ commit }, id) {

    return new Promise((resolve, reject) => { 
      PropertyService.deleteProperty(id).then(response=> {
        resolve(response.data)
    })
    .catch(error=>{ reject(error) })
    });
  },

  // eslint-disable-next-line no-unused-vars
  updateProperty ({ commit }, property) {

    return new Promise((resolve, reject) => { 
      PropertyService.updateProperty(property).then(response=> {
        resolve(response.data)
    })
    .catch(error=>{ reject(error) })
    });
  },

  // eslint-disable-next-line no-unused-vars  
  getPropertyGroups ({ commit },params) {

    return new Promise((resolve, reject) => { 
      PropertyService.getPropertyGroups(params).then(response=> {
        resolve(response.data)
    })
    .catch(error=>{ reject(error) })
    });
  },

  // eslint-disable-next-line no-unused-vars
  createPropertyGroup ({ commit }, payload) {

    return new Promise((resolve, reject) => { 
      PropertyService.createPropertyGroup(payload).then(response=> {
        resolve(response.data)
    })
    .catch(error=>{ reject(error) })
    });
  },

  // eslint-disable-next-line no-unused-vars
  deletePropertyGroup ({ commit }, id) {

    return new Promise((resolve, reject) => { 
      PropertyService.deletePropertyGroup(id).then(response=> {
        resolve(response.data)
    })
    .catch(error=>{ reject(error) })
    });
  },

  // eslint-disable-next-line no-unused-vars
  updatePropertyGroup ({ commit }, propertyGroup) {
    return new Promise((resolve, reject) => { 
      PropertyService.updatePropertyGroup(propertyGroup).then(response=> {
        resolve(response.data)
    })
    .catch(error=>{ reject(error) })
    });
  }
} 